import Icon from '../components/Icon.vue'

Icon.register({"pie-chart":{"width":1792,"height":1792,"paths":[{"d":"M768 890l546 546q-106 108-247.5 168t-298.5 60q-209 0-385.5-103t-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103v762zM955 896h773q0 157-60 298.5t-168 247.5zM1664 768h-768v-768q209 0 385.5 103t279.5 279.5 103 385.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pie-chart.js
// module id = 1620
// module chunks = 0